import { TRANSLATE } from '../../shared/classes/translatable';

export interface IEntite {
    id: string;
    code?: string;
    libelle: string;
}

export class Entite implements IEntite {

    id: string;
    code?: string;
    libelle: string;

    constructor(entite: IEntite) {
        this.id = entite.id;
        this.code = entite.code;
        this.libelle = entite.libelle;
    }

    static fromJson(data: any): IEntite {
        return new Entite({
            id: data.ent_id,
            code: data.ent_code,
            libelle: data.eli_libelle
        });
    }

    // Liste de toutes les entités dispo et leur nom avant renommage (utilisé dans configuration / personnalisation / renommage entités)
    static getEntiteOriginalName() {
        return {
            batiment: TRANSLATE('Bâtiment'),
            bien: TRANSLATE('Bien'),
            contact: TRANSLATE('Contact'),
            locataire: TRANSLATE('Locataire'),
            proprietaire: TRANSLATE('Client'),
            prospect: TRANSLATE('Prospect'),
            utilisateur: TRANSLATE('Utilisateur'),
            bureau: TRANSLATE('Bureau'),
            fournisseur: TRANSLATE('Fournisseur'),
            maitre_ouvrage: TRANSLATE('Maîtrise d\'ouvrage'),
        };
    }
}
